(function () {
  var sliderArgs = {
    autoPlay: 5000,
    avoidReflow: true,
    cellAlign: document.documentElement.dir === "rtl" ? "right" : "left",
  };

  function initSection(container) {
    var slider = container.querySelector(".announcement-slider");
    if (!slider) return;
    if (parseInt(slider.dataset.blockCount) <= 1) return;

    if (slider._flickity && typeof slider._flickity.destroy === "function") {
      slider._flickity.destroy();
    }

    slider._flickity = new theme.Slideshow(slider, sliderArgs);
  }

  function destroySection(container) {
    var slider = container.querySelector(".announcement-slider");
    if (!slider || !slider._flickity) return;
    if (typeof slider._flickity.destroy === "function") {
      slider._flickity.destroy();
      slider._flickity = null;
    }
  }

  function initAll() {
    document
      .querySelectorAll('[data-section-type="announcement-banner"]')
      .forEach(function (container) {
        initSection(container);
      });
  }

  // Always wait for DOMContentLoaded so theme.Slideshow is guaranteed ready
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }

  // Shopify editor events
  document.addEventListener("shopify:section:load", function (evt) {
    var container = evt.target.querySelector(
      '[data-section-type="announcement-banner"]'
    );
    if (container) initSection(container);
  });

  document.addEventListener("shopify:section:unload", function (evt) {
    var container = evt.target.querySelector(
      '[data-section-type="announcement-banner"]'
    );
    if (container) destroySection(container);
  });

  document.addEventListener("shopify:block:select", function (evt) {
    var container = evt.target.closest(
      '[data-section-type="announcement-banner"]'
    );
    if (!container) return;
    var slider = container.querySelector(".announcement-slider");
    if (!slider || !slider._flickity) return;
    var index = parseInt(evt.target.dataset.index);
    if (!isNaN(index)) {
      slider._flickity.goToSlide(index);
      if (typeof slider._flickity.pause === "function") {
        slider._flickity.pause();
      }
    }
  });

  document.addEventListener("shopify:block:deselect", function (evt) {
    var container = evt.target.closest(
      '[data-section-type="announcement-banner"]'
    );
    if (!container) return;
    var slider = container.querySelector(".announcement-slider");
    if (!slider || !slider._flickity) return;
    if (typeof slider._flickity.play === "function") {
      slider._flickity.play();
    }
  });
})();
